import { applyMiddleware, compose, createStore } from 'redux';
import 'babel-regenerator-runtime'; // necessary before redux-saga
import createSagaMiddleware from 'redux-saga';

import { rootReducer } from './reducers';
import { rootSagas } from './sagas';

const initialState = window.appState || {};
const sagaMiddleware = createSagaMiddleware();
// https://chrome.google.com/webstore/detail/redux-devtools/lmhkpmbekcpmknklioeibfkpmmfibljd?hl=en
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
export const store = createStore(rootReducer, initialState, composeEnhancers(
    applyMiddleware(sagaMiddleware),
));
rootSagas.map(saga => sagaMiddleware.run(saga));



// WEBPACK FOOTER //
// ./app/redux.js